import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-stripe-checkout',
  imports: [],
  template: ``,
})
export class StripeCheckoutComponent {}
